import {throttle} from '@yandex-delivery/utils'
import {useEffect, useState} from 'react'

export function useClientHeight() {
  const [heigth, setHeight] = useState<number>(document.documentElement.clientHeight)

  useEffect(() => {
    const onResize = throttle(200, () => {
      setHeight(document.documentElement.clientHeight)
    })

    window.addEventListener('resize', onResize)

    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [])

  return heigth
}
